// Base Camp — Microsoft Entra (MSAL) konfiguracija za SPA (Authorization Code + PKCE).
// Vrednosti dolaze iz .env (REACT_APP_MSAL_*). Single-tenant: authority je vezan
// za nas tenant, pa se mogu prijaviti SAMO @hansenbeck.com nalozi iz nase org.

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: '/login',
  },
  cache: {
    // localStorage: sesija prezivljava refresh taba. Tokeni su kratkotrajni;
    // backend svakako ponovo verifikuje ID token pri svakoj prijavi.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

// Scopes za login. openid/profile/email su OIDC standard; User.Read je Graph
// delegated permission koji smo konfigurisali u app registraciji.
// prompt: 'select_account' -> korisnik uvek moze da izabere / promeni nalog.
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
  prompt: 'select_account',
};
